export const CART_LIMIT_EXCEEDED = 'cart_limit_exceeded'

const addToCartErrorHandler = (error, setError) => {
    let errorData = [
        'Unable to add to cart. Refresh the page and try again or contact support.',
    ]
    if (error.response) {
        const responseData = error.response.data
        if (responseData.message) {
            errorData = [responseData.message]
        }

        if (
            responseData.error_code &&
            responseData.error_code === CART_LIMIT_EXCEEDED
        ) {
            errorData = [
                'You have exceeded your order limit. No more cards can be added.',
            ]
        }
        if (responseData.errors) {
            for (const property in responseData.errors) {
                if (responseData.errors.hasOwnProperty(property)) {
                    errorData = errorData.concat(responseData.errors[property])
                }
            }
        }
    } else if (typeof error === 'string') {
        errorData = [error]
    }

    setError(errorData)
}

export default addToCartErrorHandler
